import _objectWithoutProperties from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "size", "aria-label", "aria-hidden"],
  _excluded2 = ["children", "aria-label", "aria-hidden"],
  _excluded3 = ["children", "aria-label", "aria-labelledby", "aria-hidden"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "./main.css";
import { baseStyleProps as $1Thsl$baseStyleProps, useSlotProps as $1Thsl$useSlotProps, useStyleProps as $1Thsl$useStyleProps, classNames as $1Thsl$classNames } from "@react-spectrum/utils";
import { filterDOMProps as $1Thsl$filterDOMProps } from "@react-aria/utils";
import $1Thsl$react from "react";
import { useProvider as $1Thsl$useProvider } from "@react-spectrum/provider";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $6edfbdaffbc9baf9$exports = {};
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon", function () {
  return $6edfbdaffbc9baf9$export$d374b04f30360026;
}, function (v) {
  return $6edfbdaffbc9baf9$export$d374b04f30360026 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon", function () {
  return $6edfbdaffbc9baf9$export$c7db7fdc5aac13aa;
}, function (v) {
  return $6edfbdaffbc9baf9$export$c7db7fdc5aac13aa = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXXS", function () {
  return $6edfbdaffbc9baf9$export$cab8448604b31f43;
}, function (v) {
  return $6edfbdaffbc9baf9$export$cab8448604b31f43 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXS", function () {
  return $6edfbdaffbc9baf9$export$557c0af6873b4222;
}, function (v) {
  return $6edfbdaffbc9baf9$export$557c0af6873b4222 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeS", function () {
  return $6edfbdaffbc9baf9$export$34ce05647f0c65e;
}, function (v) {
  return $6edfbdaffbc9baf9$export$34ce05647f0c65e = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeM", function () {
  return $6edfbdaffbc9baf9$export$8f1693ac47916bbf;
}, function (v) {
  return $6edfbdaffbc9baf9$export$8f1693ac47916bbf = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeL", function () {
  return $6edfbdaffbc9baf9$export$8d23c37ef2a4f13e;
}, function (v) {
  return $6edfbdaffbc9baf9$export$8d23c37ef2a4f13e = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXL", function () {
  return $6edfbdaffbc9baf9$export$c6e70a22e841bc1b;
}, function (v) {
  return $6edfbdaffbc9baf9$export$c6e70a22e841bc1b = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXXL", function () {
  return $6edfbdaffbc9baf9$export$b37777493a27e620;
}, function (v) {
  return $6edfbdaffbc9baf9$export$b37777493a27e620 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum--medium", function () {
  return $6edfbdaffbc9baf9$export$4c0c83b3f4303ef8;
}, function (v) {
  return $6edfbdaffbc9baf9$export$4c0c83b3f4303ef8 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon--large", function () {
  return $6edfbdaffbc9baf9$export$2265a487ad399d8b;
}, function (v) {
  return $6edfbdaffbc9baf9$export$2265a487ad399d8b = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon--medium", function () {
  return $6edfbdaffbc9baf9$export$a6044013cf72ddc9;
}, function (v) {
  return $6edfbdaffbc9baf9$export$a6044013cf72ddc9 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum--large", function () {
  return $6edfbdaffbc9baf9$export$a88a8dbe29386d31;
}, function (v) {
  return $6edfbdaffbc9baf9$export$a88a8dbe29386d31 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-AlertMedium", function () {
  return $6edfbdaffbc9baf9$export$83be8302c01b6478;
}, function (v) {
  return $6edfbdaffbc9baf9$export$83be8302c01b6478 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-AlertSmall", function () {
  return $6edfbdaffbc9baf9$export$57b49d6ee2e9f187;
}, function (v) {
  return $6edfbdaffbc9baf9$export$57b49d6ee2e9f187 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ArrowDownSmall", function () {
  return $6edfbdaffbc9baf9$export$81968d05e3681b3f;
}, function (v) {
  return $6edfbdaffbc9baf9$export$81968d05e3681b3f = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ArrowLeftMedium", function () {
  return $6edfbdaffbc9baf9$export$c0d655f335b5bc31;
}, function (v) {
  return $6edfbdaffbc9baf9$export$c0d655f335b5bc31 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-Asterisk", function () {
  return $6edfbdaffbc9baf9$export$cca4342eca45562;
}, function (v) {
  return $6edfbdaffbc9baf9$export$cca4342eca45562 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CheckmarkMedium", function () {
  return $6edfbdaffbc9baf9$export$edc4a2e9af971b26;
}, function (v) {
  return $6edfbdaffbc9baf9$export$edc4a2e9af971b26 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CheckmarkSmall", function () {
  return $6edfbdaffbc9baf9$export$9e665cb12e71e037;
}, function (v) {
  return $6edfbdaffbc9baf9$export$9e665cb12e71e037 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronDownMedium", function () {
  return $6edfbdaffbc9baf9$export$2f91b7a7627906d5;
}, function (v) {
  return $6edfbdaffbc9baf9$export$2f91b7a7627906d5 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronDownSmall", function () {
  return $6edfbdaffbc9baf9$export$56efb4ec9eb35c07;
}, function (v) {
  return $6edfbdaffbc9baf9$export$56efb4ec9eb35c07 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronLeftLarge", function () {
  return $6edfbdaffbc9baf9$export$5861dfe1d581a528;
}, function (v) {
  return $6edfbdaffbc9baf9$export$5861dfe1d581a528 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronLeftMedium", function () {
  return $6edfbdaffbc9baf9$export$595a122b60890c78;
}, function (v) {
  return $6edfbdaffbc9baf9$export$595a122b60890c78 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronRightLarge", function () {
  return $6edfbdaffbc9baf9$export$596373794435f8bc;
}, function (v) {
  return $6edfbdaffbc9baf9$export$596373794435f8bc = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronRightMedium", function () {
  return $6edfbdaffbc9baf9$export$32b379a02cafbfb3;
}, function (v) {
  return $6edfbdaffbc9baf9$export$32b379a02cafbfb3 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronRightSmall", function () {
  return $6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4;
}, function (v) {
  return $6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronUpSmall", function () {
  return $6edfbdaffbc9baf9$export$c1cbae72fd236fd9;
}, function (v) {
  return $6edfbdaffbc9baf9$export$c1cbae72fd236fd9 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CornerTriangle", function () {
  return $6edfbdaffbc9baf9$export$636d8cde4f6b7e6;
}, function (v) {
  return $6edfbdaffbc9baf9$export$636d8cde4f6b7e6 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CrossLarge", function () {
  return $6edfbdaffbc9baf9$export$1f0ad4082256e3df;
}, function (v) {
  return $6edfbdaffbc9baf9$export$1f0ad4082256e3df = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CrossMedium", function () {
  return $6edfbdaffbc9baf9$export$1e0848411e254295;
}, function (v) {
  return $6edfbdaffbc9baf9$export$1e0848411e254295 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CrossSmall", function () {
  return $6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5;
}, function (v) {
  return $6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-DashSmall", function () {
  return $6edfbdaffbc9baf9$export$98de2b9917cd3b6a;
}, function (v) {
  return $6edfbdaffbc9baf9$export$98de2b9917cd3b6a = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-DoubleGripper", function () {
  return $6edfbdaffbc9baf9$export$3c956876cb11c1e1;
}, function (v) {
  return $6edfbdaffbc9baf9$export$3c956876cb11c1e1 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-FolderBreadcrumb", function () {
  return $6edfbdaffbc9baf9$export$55cf2795737352fc;
}, function (v) {
  return $6edfbdaffbc9baf9$export$55cf2795737352fc = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-HelpMedium", function () {
  return $6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5;
}, function (v) {
  return $6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-HelpSmall", function () {
  return $6edfbdaffbc9baf9$export$f51b22382127207d;
}, function (v) {
  return $6edfbdaffbc9baf9$export$f51b22382127207d = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-InfoMedium", function () {
  return $6edfbdaffbc9baf9$export$825a6c2340d3b7e5;
}, function (v) {
  return $6edfbdaffbc9baf9$export$825a6c2340d3b7e5 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-InfoSmall", function () {
  return $6edfbdaffbc9baf9$export$4828f4a6bfd26c04;
}, function (v) {
  return $6edfbdaffbc9baf9$export$4828f4a6bfd26c04 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ListGripper", function () {
  return $6edfbdaffbc9baf9$export$1254ece141a8dac6;
}, function (v) {
  return $6edfbdaffbc9baf9$export$1254ece141a8dac6 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-Magnifier", function () {
  return $6edfbdaffbc9baf9$export$a33650c9f4cc191e;
}, function (v) {
  return $6edfbdaffbc9baf9$export$a33650c9f4cc191e = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SkipLeft", function () {
  return $6edfbdaffbc9baf9$export$9eb19533e4b8cc28;
}, function (v) {
  return $6edfbdaffbc9baf9$export$9eb19533e4b8cc28 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SkipRight", function () {
  return $6edfbdaffbc9baf9$export$67704939e41f705a;
}, function (v) {
  return $6edfbdaffbc9baf9$export$67704939e41f705a = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-Star", function () {
  return $6edfbdaffbc9baf9$export$c4d219c150b98c92;
}, function (v) {
  return $6edfbdaffbc9baf9$export$c4d219c150b98c92 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-StarOutline", function () {
  return $6edfbdaffbc9baf9$export$bcda0a6a6d7202af;
}, function (v) {
  return $6edfbdaffbc9baf9$export$bcda0a6a6d7202af = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SuccessMedium", function () {
  return $6edfbdaffbc9baf9$export$d18d2d837989a797;
}, function (v) {
  return $6edfbdaffbc9baf9$export$d18d2d837989a797 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SuccessSmall", function () {
  return $6edfbdaffbc9baf9$export$506ac7a1a72a2c65;
}, function (v) {
  return $6edfbdaffbc9baf9$export$506ac7a1a72a2c65 = v;
});
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-TripleGripper", function () {
  return $6edfbdaffbc9baf9$export$12b8600bcd969018;
}, function (v) {
  return $6edfbdaffbc9baf9$export$12b8600bcd969018 = v;
});
var $6edfbdaffbc9baf9$export$d374b04f30360026;
var $6edfbdaffbc9baf9$export$c7db7fdc5aac13aa;
var $6edfbdaffbc9baf9$export$cab8448604b31f43;
var $6edfbdaffbc9baf9$export$557c0af6873b4222;
var $6edfbdaffbc9baf9$export$34ce05647f0c65e;
var $6edfbdaffbc9baf9$export$8f1693ac47916bbf;
var $6edfbdaffbc9baf9$export$8d23c37ef2a4f13e;
var $6edfbdaffbc9baf9$export$c6e70a22e841bc1b;
var $6edfbdaffbc9baf9$export$b37777493a27e620;
var $6edfbdaffbc9baf9$export$4c0c83b3f4303ef8;
var $6edfbdaffbc9baf9$export$2265a487ad399d8b;
var $6edfbdaffbc9baf9$export$a6044013cf72ddc9;
var $6edfbdaffbc9baf9$export$a88a8dbe29386d31;
var $6edfbdaffbc9baf9$export$83be8302c01b6478;
var $6edfbdaffbc9baf9$export$57b49d6ee2e9f187;
var $6edfbdaffbc9baf9$export$81968d05e3681b3f;
var $6edfbdaffbc9baf9$export$c0d655f335b5bc31;
var $6edfbdaffbc9baf9$export$cca4342eca45562;
var $6edfbdaffbc9baf9$export$edc4a2e9af971b26;
var $6edfbdaffbc9baf9$export$9e665cb12e71e037;
var $6edfbdaffbc9baf9$export$2f91b7a7627906d5;
var $6edfbdaffbc9baf9$export$56efb4ec9eb35c07;
var $6edfbdaffbc9baf9$export$5861dfe1d581a528;
var $6edfbdaffbc9baf9$export$595a122b60890c78;
var $6edfbdaffbc9baf9$export$596373794435f8bc;
var $6edfbdaffbc9baf9$export$32b379a02cafbfb3;
var $6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4;
var $6edfbdaffbc9baf9$export$c1cbae72fd236fd9;
var $6edfbdaffbc9baf9$export$636d8cde4f6b7e6;
var $6edfbdaffbc9baf9$export$1f0ad4082256e3df;
var $6edfbdaffbc9baf9$export$1e0848411e254295;
var $6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5;
var $6edfbdaffbc9baf9$export$98de2b9917cd3b6a;
var $6edfbdaffbc9baf9$export$3c956876cb11c1e1;
var $6edfbdaffbc9baf9$export$55cf2795737352fc;
var $6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5;
var $6edfbdaffbc9baf9$export$f51b22382127207d;
var $6edfbdaffbc9baf9$export$825a6c2340d3b7e5;
var $6edfbdaffbc9baf9$export$4828f4a6bfd26c04;
var $6edfbdaffbc9baf9$export$1254ece141a8dac6;
var $6edfbdaffbc9baf9$export$a33650c9f4cc191e;
var $6edfbdaffbc9baf9$export$9eb19533e4b8cc28;
var $6edfbdaffbc9baf9$export$67704939e41f705a;
var $6edfbdaffbc9baf9$export$c4d219c150b98c92;
var $6edfbdaffbc9baf9$export$bcda0a6a6d7202af;
var $6edfbdaffbc9baf9$export$d18d2d837989a797;
var $6edfbdaffbc9baf9$export$506ac7a1a72a2c65;
var $6edfbdaffbc9baf9$export$12b8600bcd969018;
$6edfbdaffbc9baf9$export$d374b04f30360026 = "spectrum-Icon_368b34";
$6edfbdaffbc9baf9$export$c7db7fdc5aac13aa = "spectrum-UIIcon_368b34";
$6edfbdaffbc9baf9$export$cab8448604b31f43 = "spectrum-Icon--sizeXXS_368b34";
$6edfbdaffbc9baf9$export$557c0af6873b4222 = "spectrum-Icon--sizeXS_368b34";
$6edfbdaffbc9baf9$export$34ce05647f0c65e = "spectrum-Icon--sizeS_368b34";
$6edfbdaffbc9baf9$export$8f1693ac47916bbf = "spectrum-Icon--sizeM_368b34";
$6edfbdaffbc9baf9$export$8d23c37ef2a4f13e = "spectrum-Icon--sizeL_368b34";
$6edfbdaffbc9baf9$export$c6e70a22e841bc1b = "spectrum-Icon--sizeXL_368b34";
$6edfbdaffbc9baf9$export$b37777493a27e620 = "spectrum-Icon--sizeXXL_368b34";
$6edfbdaffbc9baf9$export$4c0c83b3f4303ef8 = "spectrum--medium_368b34";
$6edfbdaffbc9baf9$export$2265a487ad399d8b = "spectrum-UIIcon--large_368b34";
$6edfbdaffbc9baf9$export$a6044013cf72ddc9 = "spectrum-UIIcon--medium_368b34";
$6edfbdaffbc9baf9$export$a88a8dbe29386d31 = "spectrum--large_368b34";
$6edfbdaffbc9baf9$export$83be8302c01b6478 = "spectrum-UIIcon-AlertMedium_368b34";
$6edfbdaffbc9baf9$export$57b49d6ee2e9f187 = "spectrum-UIIcon-AlertSmall_368b34";
$6edfbdaffbc9baf9$export$81968d05e3681b3f = "spectrum-UIIcon-ArrowDownSmall_368b34";
$6edfbdaffbc9baf9$export$c0d655f335b5bc31 = "spectrum-UIIcon-ArrowLeftMedium_368b34";
$6edfbdaffbc9baf9$export$cca4342eca45562 = "spectrum-UIIcon-Asterisk_368b34";
$6edfbdaffbc9baf9$export$edc4a2e9af971b26 = "spectrum-UIIcon-CheckmarkMedium_368b34";
$6edfbdaffbc9baf9$export$9e665cb12e71e037 = "spectrum-UIIcon-CheckmarkSmall_368b34";
$6edfbdaffbc9baf9$export$2f91b7a7627906d5 = "spectrum-UIIcon-ChevronDownMedium_368b34";
$6edfbdaffbc9baf9$export$56efb4ec9eb35c07 = "spectrum-UIIcon-ChevronDownSmall_368b34";
$6edfbdaffbc9baf9$export$5861dfe1d581a528 = "spectrum-UIIcon-ChevronLeftLarge_368b34";
$6edfbdaffbc9baf9$export$595a122b60890c78 = "spectrum-UIIcon-ChevronLeftMedium_368b34";
$6edfbdaffbc9baf9$export$596373794435f8bc = "spectrum-UIIcon-ChevronRightLarge_368b34";
$6edfbdaffbc9baf9$export$32b379a02cafbfb3 = "spectrum-UIIcon-ChevronRightMedium_368b34";
$6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4 = "spectrum-UIIcon-ChevronRightSmall_368b34";
$6edfbdaffbc9baf9$export$c1cbae72fd236fd9 = "spectrum-UIIcon-ChevronUpSmall_368b34";
$6edfbdaffbc9baf9$export$636d8cde4f6b7e6 = "spectrum-UIIcon-CornerTriangle_368b34";
$6edfbdaffbc9baf9$export$1f0ad4082256e3df = "spectrum-UIIcon-CrossLarge_368b34";
$6edfbdaffbc9baf9$export$1e0848411e254295 = "spectrum-UIIcon-CrossMedium_368b34";
$6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5 = "spectrum-UIIcon-CrossSmall_368b34";
$6edfbdaffbc9baf9$export$98de2b9917cd3b6a = "spectrum-UIIcon-DashSmall_368b34";
$6edfbdaffbc9baf9$export$3c956876cb11c1e1 = "spectrum-UIIcon-DoubleGripper_368b34";
$6edfbdaffbc9baf9$export$55cf2795737352fc = "spectrum-UIIcon-FolderBreadcrumb_368b34";
$6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5 = "spectrum-UIIcon-HelpMedium_368b34";
$6edfbdaffbc9baf9$export$f51b22382127207d = "spectrum-UIIcon-HelpSmall_368b34";
$6edfbdaffbc9baf9$export$825a6c2340d3b7e5 = "spectrum-UIIcon-InfoMedium_368b34";
$6edfbdaffbc9baf9$export$4828f4a6bfd26c04 = "spectrum-UIIcon-InfoSmall_368b34";
$6edfbdaffbc9baf9$export$1254ece141a8dac6 = "spectrum-UIIcon-ListGripper_368b34";
$6edfbdaffbc9baf9$export$a33650c9f4cc191e = "spectrum-UIIcon-Magnifier_368b34";
$6edfbdaffbc9baf9$export$9eb19533e4b8cc28 = "spectrum-UIIcon-SkipLeft_368b34";
$6edfbdaffbc9baf9$export$67704939e41f705a = "spectrum-UIIcon-SkipRight_368b34";
$6edfbdaffbc9baf9$export$c4d219c150b98c92 = "spectrum-UIIcon-Star_368b34";
$6edfbdaffbc9baf9$export$bcda0a6a6d7202af = "spectrum-UIIcon-StarOutline_368b34";
$6edfbdaffbc9baf9$export$d18d2d837989a797 = "spectrum-UIIcon-SuccessMedium_368b34";
$6edfbdaffbc9baf9$export$506ac7a1a72a2c65 = "spectrum-UIIcon-SuccessSmall_368b34";
$6edfbdaffbc9baf9$export$12b8600bcd969018 = "spectrum-UIIcon-TripleGripper_368b34";
function $6bfb67578ee6effd$var$iconColorValue(value) {
  return "var(--spectrum-semantic-".concat(value, "-color-icon)");
}
var $6bfb67578ee6effd$var$iconStyleProps = _objectSpread(_objectSpread({}, $1Thsl$baseStyleProps), {}, {
  color: ['color', $6bfb67578ee6effd$var$iconColorValue]
});
function $6bfb67578ee6effd$export$f04a61298a47a40f(props) {
  props = $1Thsl$useSlotProps(props, 'icon');
  var _props = props,
    children = _props.children,
    size = _props.size,
    ariaLabel = _props['aria-label'],
    ariaHidden = _props['aria-hidden'],
    otherProps = _objectWithoutProperties(_props, _excluded);
  var _$1Thsl$useStyleProps = $1Thsl$useStyleProps(otherProps, $6bfb67578ee6effd$var$iconStyleProps),
    styleProps = _$1Thsl$useStyleProps.styleProps;
  var provider = $1Thsl$useProvider();
  var scale = 'M';
  if (provider !== null) scale = provider.scale === 'large' ? 'L' : 'M';
  if (!ariaHidden) ariaHidden = undefined;
  // Use user specified size, falling back to provider scale if size is undef
  var iconSize = size ? size : scale;
  return /*#__PURE__*/$1Thsl$react.cloneElement(children, _objectSpread(_objectSpread(_objectSpread({}, $1Thsl$filterDOMProps(otherProps)), styleProps), {}, {
    focusable: 'false',
    'aria-label': ariaLabel,
    'aria-hidden': ariaLabel ? ariaHidden || undefined : true,
    role: 'img',
    className: $1Thsl$classNames( /*@__PURE__*/$parcel$interopDefault($6edfbdaffbc9baf9$exports), children.props.className, 'spectrum-Icon', "spectrum-Icon--size".concat(iconSize), styleProps.className)
  }));
}
function $9ba43a63383852e3$export$906cc5990ff10700(props) {
  props = $1Thsl$useSlotProps(props, 'icon');
  var _props2 = props,
    children = _props2.children,
    ariaLabel = _props2['aria-label'],
    ariaHidden = _props2['aria-hidden'],
    otherProps = _objectWithoutProperties(_props2, _excluded2);
  var _$1Thsl$useStyleProps2 = $1Thsl$useStyleProps(otherProps),
    styleProps = _$1Thsl$useStyleProps2.styleProps;
  var provider = $1Thsl$useProvider();
  var scale = 'M';
  if (provider !== null) scale = provider.scale === 'large' ? 'L' : 'M';
  if (!ariaHidden) ariaHidden = undefined;
  return /*#__PURE__*/$1Thsl$react.cloneElement(children, _objectSpread(_objectSpread(_objectSpread({}, $1Thsl$filterDOMProps(otherProps)), styleProps), {}, {
    scale: scale,
    focusable: 'false',
    'aria-label': ariaLabel,
    'aria-hidden': ariaLabel ? ariaHidden || undefined : true,
    role: 'img',
    className: $1Thsl$classNames( /*@__PURE__*/$parcel$interopDefault($6edfbdaffbc9baf9$exports), children.props.className, 'spectrum-Icon', _defineProperty({}, "spectrum-UIIcon-".concat(children.type['displayName']), children.type['displayName']), styleProps.className)
  }));
}
function $88bb85359d3a4aed$export$d43c2e2ca9b2c105(props) {
  props = $1Thsl$useSlotProps(props, 'illustration');
  var _props3 = props,
    children = _props3.children,
    ariaLabel = _props3['aria-label'],
    ariaLabelledby = _props3['aria-labelledby'],
    ariaHidden = _props3['aria-hidden'],
    otherProps = _objectWithoutProperties(_props3, _excluded3);
  var _$1Thsl$useStyleProps3 = $1Thsl$useStyleProps(otherProps),
    styleProps = _$1Thsl$useStyleProps3.styleProps;
  var hasLabel = ariaLabel || ariaLabelledby;
  if (!ariaHidden) ariaHidden = undefined;
  return /*#__PURE__*/$1Thsl$react.cloneElement(children, _objectSpread(_objectSpread(_objectSpread({}, $1Thsl$filterDOMProps(otherProps)), styleProps), {}, {
    focusable: 'false',
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    'aria-hidden': ariaHidden,
    role: hasLabel ? 'img' : undefined
  }));
}
export { $6bfb67578ee6effd$export$f04a61298a47a40f as Icon, $9ba43a63383852e3$export$906cc5990ff10700 as UIIcon, $88bb85359d3a4aed$export$d43c2e2ca9b2c105 as Illustration };